import { render } from "./ResolutionDetails.vue?vue&type=template&id=77b68617&scoped=true"
import script from "./ResolutionDetails.vue?vue&type=script&lang=js"
export * from "./ResolutionDetails.vue?vue&type=script&lang=js"

import "./ResolutionDetails.vue?vue&type=style&index=0&id=77b68617&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b68617"]])

export default __exports__